import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const HotWordContent = ({ content, index }) => {
    const data = content.hotWords[index];

    return (
        <div>
            <div className={styles.banner}>
                <span>{data.title}</span>
            </div>
            <div className={styles.articleWp}>
                {
                    data.subTitle && data.subTitle.map((item, index) => {
                        return (
                            <div className={styles.article} key={index}>
                                <div className={styles.owner}>
                                    <img className={styles.avatar} src={require('../../asset/likeqiang.png')} alt="" />
                                    李克强
                                </div>
                                <div className={styles.content}>
                                    {item.content}
                                </div>
                                <img className={styles.img} src={item.image} alt="" />
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

HotWordContent.propTypes = {
    content: PropTypes.object,
    index: PropTypes.number
};

export default errorBoundary(HotWordContent);
